import ScheduleForm from "./components/ScheduleForm";
import { AmazonConnectApp } from "@amazon-connect/app";

const { connectApp } = AmazonConnectApp.init({
  onCreate: (event) => {
    const { appInstanceId } = event.context;
    console.log("App initialized: ", appInstanceId);
  },
  onDestroy: () => {
    console.log("App being destroyed");
  },
});

function App() {
  return <ScheduleForm />;
}

export default App;
